<template>
	<div
		v-if="focusingField === 'project'"
		class="tableSection sectionRecommended"
	>
		<button
			:class="{
				projectFieldButton: true,
				userSelectedProject: userChoiceOfProjectName === 'All'
			}"
			@click="userChooseAProject({ Name: 'All' }, $event)"
		>
			All Projects
		</button>
		<button
			:class="{
				projectFieldButton: true,
				userSelectedProject: userChoiceOfProjectName === project.Name
			}"
			v-for="(project, projectKey) in projects"
			:index="projectKey"
			:key="projectKey"
			@click="userChooseAProject(project, $event)"
		>
			{{ project.Name }}
		</button>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	props: ["focusingField", "userChoiceOfProjectName", "userChooseAProject"],
	mounted() {
		if (!this.$store.state.attributes.project) {
			this.isLoading = true;
			this.$store.dispatch("loadAttribute").finally(() => {
				this.isLoading = false;
			});
		} else {
			this.isLoading = false;
		}
	},
	computed: {
		...mapState(["attributes", "isExportSuccessful"]),
		projects: {
			get: function() {
				if (this.$store) {
					return _.sortBy(this.$store.state.attributes.project, [
						function(data) {
							return data.Sort;
						}
					]);
				}
				return [];
			},
			set: function(newValue) {
				this.updateProjectOrder(newValue);
			}
		}
	}
};
</script>
